module.exports = __webpack_public_path__ + "static/media/cert_143.8a85c14d.jpg";